import React from "react";
import { Helmet } from "react-helmet";
import "./css/aboutstyle.css";

import Header from "./components/Header";
import Footer from "./components/Footer";

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Krisula GlobExim</title>

        <meta charSet="UTF-8" />
  <link rel="icon" href="/fav.ico" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        />

        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
        />
      </Helmet>

      {/* HEADER */}
      <Header />

      {/* HERO */}
      <section className="hero">
        <div className="overlay"></div>

        <div className="hero-content">
          <h1>About Us</h1>

          <div className="breadcrumb">
            <span>Home</span>
            <span>/</span>
            <span>About Us</span>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="about-section">
        <div className="container about-grid">
          <div className="about-image">
            <img
              src="https://images.unsplash.com/photo-1500937386664-56d1dfef3854?q=80&w=1200&auto=format&fit=crop"
              alt="Agriculture"
            />
          </div>

          <div className="about-content">
            <span className="section-tag">About Company</span>

            <h2>M/s. KRISULA GLOBEXIM PVT LTD</h2>

            <p>
              M/s. Krisula Globexim Pvt. Ltd. is a trustworthy Exporter,
              Importer, Dealer, Trader, Wholesaler, Distributor and Supplier
              of Agricultural Products.
            </p>

            <p>
              We deal with Fresh Fruits, Fresh Vegetables, Rice and Wheat
              domestically and internationally.
            </p>

            <p>
              We greet and treat our valuable customers with esteem by
              providing hygienic and easy to handle packaging options.
            </p>

            <p>
              We follow strategic integrated shipment processes to ensure
              successful consignment delivery across global markets.
            </p>
          </div>
        </div>
      </section>

      {/* MISSION */}
      <section className="mission-section">
        <div className="container mission-grid">
          <div className="mission-card">
            <i className="fa-solid fa-bullseye"></i>
            <h3>Mission</h3>
            <p>
              We believe that quality is our attitude and philosophy
              integrated in our processes.
            </p>
          </div>

          <div className="mission-card">
            <i className="fa-solid fa-earth-asia"></i>
            <h3>Objective</h3>
            <p>
              To create nourishing leadership for healthy agricultural
              products in domestic and international markets.
            </p>
          </div>

          <div className="mission-card">
            <i className="fa-solid fa-handshake"></i>
            <h3>Commitment</h3>
            <p>
              We serve our customers with utmost transparency and professionalism.
            </p>
          </div>
        </div>
      </section>

      {/* EXPORT MARKETS */}
      <section className="markets-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Global Presence</span>
            <h2>Export Markets</h2>
          </div>

          <div className="market-grid">
            <div className="market-card">Middle East</div>
            <div className="market-card">South East Asia</div>
            <div className="market-card">Far East</div>
            <div className="market-card">USA</div>
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="values-section">
        <div className="container">
          <div className="section-header">
            <span className="section-tag">Core Values</span>
            <h2>What Makes Us Different</h2>
          </div>

          <div className="values-grid">
            <div className="value-box">
              <i className="fa-solid fa-seedling"></i>
              <h3>Fresh Products</h3>
              <p>
                Quality produce sourced directly from trusted farms and suppliers.
              </p>
            </div>

            <div className="value-box">
              <i className="fa-solid fa-truck-fast"></i>
              <h3>Reliable Shipment</h3>
              <p>
                Timely global logistics and secure shipment handling.
              </p>
            </div>

            <div className="value-box">
              <i className="fa-solid fa-box"></i>
              <h3>Safe Packaging</h3>
              <p>
                Hygienic and export-grade packaging solutions.
              </p>
            </div>

            <div className="value-box">
              <i className="fa-solid fa-users"></i>
              <h3>Professional Team</h3>
              <p>
                Experienced professionals committed to customer satisfaction.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container cta-content">
          <h2>Looking For Agro Product Export Solutions?</h2>
          <p>Connect with our experienced export team today.</p>
          <a href="/contact" className="cta-btn">
            Contact Us
          </a>
        </div>
      </section>

      {/* FOOTER */}
      <Footer />
    </>
  );
};

export default About;